/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Delegated_AccessInputs */

const en_nav_delegated_access = /** @type {(inputs: Nav_Delegated_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delegated access`)
};

/**
* | output |
* | --- |
* | "Delegated access" |
*
* @param {Nav_Delegated_AccessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_delegated_access = /** @type {((inputs?: Nav_Delegated_AccessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Delegated_AccessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_delegated_access(inputs)
});